import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { DateField } from '@/components/react-hook-form/DateField';
import type { Schema } from '../../schema';

export const SubmitOn: FC = () => {
  const {
    formState: { errors }
  } = useFormContext<Schema>();

  return (
    <Panel>
      <Headding>提出年月日</Headding>
      <Item>
        <DateField name="submitOn" />
        {errors.submitOn?.message && <ErrorMessage>{errors.submitOn.message}</ErrorMessage>}
      </Item>
    </Panel>
  );
};
